// const baseURL = "http://127.0.0.1:8000/"
const baseURL = "https://priyanshi.coalfeed.in/"


const config = {

    apiBaseURL : `${baseURL}`,
    staticBaseURL : `${baseURL}`,
    apiTimeout: 500000
}
export default config;